import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import React from "react"
import { View } from "react-native"
import ProgressCircle from "@Components/PercentageCircle"
import { baseColors } from "@Constants/baseStyles"
import { ActivityIndicator } from "react-native-paper"
import styles from "./styles"

export const SurveyHeader = (props) => {
    const { currentQuestionIndex, surveysList, loading, axisName, bgColor, allAxis, forVideoPoint } = props

    return (
        <View style={[styles.container, { backgroundColor: bgColor }]}>
            <View>
                <BreeSerifText fontSize={22} color={"white"}>
                    {axisName}
                </BreeSerifText>
                {forVideoPoint && (
                    <OpenSansText fontSize={16} color={"white"}>
                        {"Dernière étape !"}
                    </OpenSansText>
                )}
            </View>

            {/* <View>
                {loading && !forVideoPoint ? (
                    <ActivityIndicator style={{ margin: 20 }} color="white" size={"small"} />
                ) : (
                    !forVideoPoint && (
                        <ProgressCircle
                            percent={forVideoPoint ? 100 : ((+currentQuestionIndex + 1) * 100) / surveysList.length}
                            radius={40}
                            borderWidth={7}
                            color={
                                bgColor == baseColors.green.primary
                                    ? baseColors.orange.primary
                                    : baseColors.green.primary
                            }
                            shadowColor="white"
                            bgColor={bgColor}
                        >
                            <OpenSansText style={{ color: "white", fontSize: 18 }}>
                                {`${+currentQuestionIndex + 1} / ${surveysList.length}`}
                            </OpenSansText>
                        </ProgressCircle>
                    )
                )}
            </View> */}
        </View>
    )
}
